var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-chip",
    {
      staticClass: "status-chip",
      class: { "cursor-pointer": _vm.clickable },
      attrs: {
        color: _vm.color,
        small: _vm.small,
        "icon-right": _vm.clickable ? "expand_more" : null
      },
      on: { click: _vm.handleClick }
    },
    [
      _c("div", { staticClass: "row items-center no-wrap" }, [
        _c(
          "div",
          [
            _vm.committed
              ? _c("q-icon", { attrs: { name: "lock", size: "1rem" } })
              : _vm._e(),
            _c("q-tooltip", [
              _vm._v(
                "\n        " + _vm._s(_vm.$t("quote_committed")) + "\n      "
              )
            ])
          ],
          1
        ),
        _c(
          "span",
          {
            class: { "on-right": _vm.committed },
            on: { click: _vm.handleClick }
          },
          [_vm._v(_vm._s(_vm.$t(_vm.status)))]
        )
      ]),
      _c(
        "q-popover",
        { ref: "popover", attrs: { disable: !_vm.clickable } },
        [
          !_vm.showNoAction
            ? _c(
                "q-list",
                { attrs: { "item-separator": "", link: "" } },
                [
                  _vm.showMarkAsAccepted
                    ? [
                        _c(
                          "q-item",
                          {
                            directives: [
                              {
                                name: "close-overlay",
                                rawName: "v-close-overlay"
                              }
                            ],
                            nativeOn: {
                              click: function($event) {
                                _vm.$emit("accepted")
                              }
                            }
                          },
                          [
                            _c("q-item-main", [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("mark_accepted")))
                              ])
                            ])
                          ],
                          1
                        )
                      ]
                    : _vm._e(),
                  _vm.showMarkAsOpen
                    ? [
                        _c(
                          "q-item",
                          {
                            directives: [
                              {
                                name: "close-overlay",
                                rawName: "v-close-overlay"
                              }
                            ],
                            nativeOn: {
                              click: function($event) {
                                _vm.$emit("open")
                              }
                            }
                          },
                          [
                            _c("q-item-main", [
                              _c("span", [_vm._v(_vm._s(_vm.$t("mark_open")))])
                            ])
                          ],
                          1
                        )
                      ]
                    : _vm._e(),
                  _c("q-item-separator"),
                  _vm.showMarkAsCanceled
                    ? [
                        _c(
                          "q-item",
                          {
                            directives: [
                              {
                                name: "close-overlay",
                                rawName: "v-close-overlay"
                              }
                            ],
                            nativeOn: {
                              click: function($event) {
                                _vm.$emit("cancel")
                              }
                            }
                          },
                          [
                            _c("q-item-main", [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("cancel_quote")))
                              ])
                            ])
                          ],
                          1
                        )
                      ]
                    : _vm._e()
                ],
                2
              )
            : _vm._e(),
          _vm.showNoAction
            ? [
                _c("div", { staticClass: "q-px-lg q-py-md" }, [
                  _c("span", { staticClass: "text-faded" }, [
                    _vm._v(_vm._s(_vm.$t("no_action_available")))
                  ])
                ])
              ]
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }